/**
 * @module experience/credit-check
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { ObjectInterface } from '@support/api/common/api-response.interface';

export class PhoneDetails {
  public primaryContactNumber: string;

  /**
   * Stores the email of the customer
   */
  public emailId: string;

  constructor(communicationFormValue: ObjectInterface) {
    this.primaryContactNumber = communicationFormValue.contactNumber;
    this.emailId = communicationFormValue.emailAddress;
  }
}
